import React from "react";
import beta_orange from "../../../../assets/images/beta_orange.svg"

export default function Title({ title, beta }) {
  return (
    <>
      <h1 className="title-container text-gray mb-4 text-center">
      {title}
      {beta === "beta" && (
        <img
          className="mb-1 logo_beta_orange"
          src={beta_orange}
          alt="logo beta fundraisin"
        />
      )}
    </h1>
      
    </>
  );
}
